export default __webpack_public_path__ + "static/media/exchange-alt-solid.2b3c92b8.svg";